import { createContentPropTypes } from '../../../helpers/content';

const content = {
	title: 'Imported payment entries',
	description: [
		'Please check the imported entries are correct before you continue.',
		'We’ll check for any problems with payee account details before we make the payments.',
		'Bacs payments must be set up and authorised before the 5.10pm cut-off time to meet your planned submission and settlement dates.',
	],
	descriptionDebit: [
		'Please check the imported entries are correct before you continue.',
		'We’ll check for any problems with payee account details before we make the payments.',
		'Bacs payments must be set up and authorised before the 5.10pm cut-off time to meet your planned submission and collection dates.',
	],
	submissionDatePopperBody:
		'This is the date you’re planning to submit your payment to Bacs for processing. Please note that Bacs payments can’t be submitted on a weekend or bank holiday.',
	settlementDatePopperBody:
		'This is the date your money will come out of your account and reach the other account – if it’s completed and authorised on time.',
	collectionDatePopperBody:
		'This is the date the money will come out the payer’s account and reach your account – if the payment request is completed and authorised on time.',
	bacsIdPopperBody:
		'This is the service user number that was issued to your company by Bacs. If you have more than one ID, simply select the one you want to use for this payment. ',
	paymentNamePopperBody:
		'Easily identify this group of payments with a unique name (such as ‘Week 24 wages’ or ’May invoices’). This is the name that’ll appear on your payment history and when authorisation is required.',
	hmrcReferencePopperBody:
		'This is an optional reference (for wages and salaries only) that’s used to help HMRC match this person’s payments with PAYE data.  It may have been provided to you by HMRC or your payroll services supplier.',
	paymentsLimitMessage: 'You’ve now reached the maximum amount of Payees that you can process at the one time.',
	continueButtonText: 'Continue',
	paymentNameInvalid: 'Enter a payment name',
	maxLimitExceededMessage: 'This exceeds the maximum amount of money you can move online per transaction.',
	bacsIdInvalid: 'Please select a Bacs ID',
	fromLabel: 'From',
	toLabel: 'To',
	submissionDateLabel: 'Submission Date',
	submissionDateDescription: 'When your payment request will be sent to Bacs',
	settlementDateLabel: 'Settlement Date',
	settlementDateDescription: 'When the money will be taken from your account and reach the other account',
	collectionDateLabel: 'Collection Date',
	collectionDateDescription: 'When the money will reach your account',
	paymentNameLabel: 'Payment Name',
	paymentNameDescription: 'You can give this payment a unique name ',
	paymentNameRequirements: 'Max 18 characters',
	bacsIdLabel: 'Bacs ID',
	bacsIdDescription: 'The service user number issued by Bacs',
	referenceLabel: 'Reference',
	hmrcReferenceLabel: 'HMRC Reference',
	amountLabel: 'Amount',
	footerText: "That's all of them.",
	fileUploadButtonText: 'Upload',
	fileImportText: 'Load up to {maxRecords} payment entries from a CSV or TXT file.',
	instructionsURLText: 'Read instructions (PDF)',
	templateURLText: 'Download an example (XLSX)',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
